import styled from 'styled-components'
import theme from '../../config/theme'
import * as HeaderUI from '@/src/shared/ui/layout/ui/header/header.styles'

export const CatalogCollapseItem = styled.div<{$level: number}>`
  border: unset;
  border-radius: unset;

  .ant-collapse {
    border-left: ${props => (props.$level == 0 && `solid 2px ${theme.colors.borderColor}`) || 'unset'};
  }

  .ant-collapse-item {
    border-bottom: unset;
  }

  .ant-collapse-content {
    border-top: unset;
  }

  & .ant-collapse-content > .ant-collapse-content-box {
    padding-right: unset;
  }

  & > .ant-collapse-item > .ant-collapse-header {
    padding: unset;
  }

  & .ant-collapse-content > .ant-collapse-content-box {
    padding-top: unset;
  }
`

export const CatalogSection = styled.div<{$level: number}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  padding: 8px 0;
  padding-left: ${props => (props.$level == 0 && '0') || '16px'};
`

export const CatalogSectionImage = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;

  img {
    /* padding: 4px; */
    max-width: 100%;
    max-height: 100%;
  }
`

export const CatalogSectionName = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    white-space: nowrap;
  }
`

export const ExpandIcon = styled.div``

export const SectionLink = styled.div<{$level: number; $root?: boolean}>`
  font-size: 100%;
  span {
    color: black;
  }
`

export const AllSectionLink = styled(SectionLink)`
  height: 40px;
  padding: 8px ${props => (props.$level == 0 && '0') || '16px'};
  margin-bottom: ${props => (props.$level == 0 && '12px') || '0'};
`

export const CatalogRootButton = styled(HeaderUI.ButtonWithIcon)`
  width: 100%;
  max-width: unset;

  &:hover {
    background: ${theme.colors.primary} !important;
  }
`

export const CatalogIconMenu = styled(HeaderUI.IconMenu)`
  position: absolute;
  left: 0;
  top: 0;
  width: 17px;
  height: 15px;

  opacity: 1;
  transition: 0.3s ease opacity;

  ${HeaderUI.ButtonWithIcon}:hover & {
    opacity: 1;
  }
`
export const CatalogIconSearch = styled(HeaderUI.IconSearch)`
  position: absolute;
  bottom: 0;
  right: 0;

  width: 10px;
  height: 10px;
  transition: 0.3s ease transform;

  ${HeaderUI.ButtonWithIcon}:hover & {
    transform: unset;
  }
`